import * as React from "react";
const SvgSwapVertical = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", fill: "currentColor", stroke: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M21,8l17,17h-13v31h-8v-31h-13z M43,56l-17,-17h13v-31h8v31h13z" }));
export default SvgSwapVertical;
